import alerts from '../helpers/storeModuleHelpers/alerts';
import axios from 'axios';
import { BASE_URL } from '@/helpers/apiUtilities.js';

export const state = {
  data: null,
  ...alerts.getState()
};

export const mutations = {
  ...alerts.mutations,
  setCart: function (state, cart) {
    state.data = cart;
  }
};

export const actions = {
  addItem: async function (store, lineItemsToAdd) {
    store.commit('clearAlerts');
    if (!store.state.data) {
      await store.dispatch('setupCart');
    }
    const checkoutId = store.state.data.id;
    this._vm.$shopify.checkout.addLineItems(checkoutId, lineItemsToAdd).then((checkout) => {
      store.commit('setCart', checkout);
      const alert = {
        status: 'success',
        message: 'You have successfully added an item to the cart.'
      };
      store.commit('addAlert', alert);
    });
  },
  removeItem: async function (store, lineItemsToRemove) {
    if (store.state.data) {
      const checkoutId = store.state.data.id;

      this._vm.$shopify.checkout.removeLineItems(checkoutId, lineItemsToRemove).then((checkout) => {
        store.commit('setCart', checkout);
      });
    }
  },
  updateItemQuantities: function (store, lineItemsToUpdate) {
    if (store.state.data) {
      const checkoutId = store.state.data.id;

      this._vm.$shopify.checkout.updateLineItems(checkoutId, lineItemsToUpdate).then((checkout) => {
        store.commit('setCart', checkout);
      });
    }
  },
  setupCart: async function (store) {
    const cartExists = await store.dispatch('getCart');
    if (!cartExists) {
      return store.dispatch('createCart');
    }
  },
  getCart: function (store) {
    const checkoutId = store.rootState.currentUser.shopifyCheckoutId;
    if (checkoutId) {
      return this._vm.$shopify.checkout.fetch(checkoutId).then((checkout) => {
        if (checkout) {
          store.commit('setCart', checkout);
          return true;
        }
        return false;
      }).catch(() => {
        return false;
      });
    }
    return false;
  },
  createCart: function (store) {
    return this._vm.$shopify.checkout.create().then((checkout) => {
      store.commit('setCart', checkout);
      store.dispatch('addCustomerToCart');
      store.dispatch('updateUser', { ShopifyCheckoutId: checkout.id }, { root: true });
    });
  },
  addCustomerToCart: function (store) {
    const checkoutId = store.state.data.id;
    const userId = store.rootState.currentUser.id;
    const input = { customAttributes: [{ key: 'preventiaUserId', value: userId }] };

    this._vm.$shopify.checkout.updateAttributes(checkoutId, input);
  },
  addPreventiaBucks: function (store) {
    const checkoutId = store.state.data.id;

    return axios.post(BASE_URL + '/PreventiaBucksDiscount')
      .then(response => {
        return this._vm.$shopify.checkout.addDiscount(checkoutId, response.data);
      });
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
